const CLICKAWAY_HANDLER_KEY = '__vueClickawayHandler__';

const onClickawayDirective = {
    beforeMount(el, binding) {
        const handler = function (event) {
            if (typeof binding.value !== 'function') {
                return;
            }
            if (el === event.target || el.contains(event.target)) {
                return;
            }
            binding.value(event);
        };

        el[CLICKAWAY_HANDLER_KEY] = handler;
        document.addEventListener('click', handler, true);
        document.addEventListener('touchstart', handler, true);
    },
    unmounted(el) {
        const handler = el[CLICKAWAY_HANDLER_KEY];
        if (!handler) {
            return;
        }
        document.removeEventListener('click', handler, true);
        document.removeEventListener('touchstart', handler, true);
        delete el[CLICKAWAY_HANDLER_KEY];
    },
};

export const mixin = {
    directives: {
        'on-clickaway': onClickawayDirective,
    },
};

export default {
    install(app) {
        app.directive('on-clickaway', onClickawayDirective);
    },
};
